import { useEffect, useMemo, useState } from 'react';
import { CallsApi, POC_CHATS, type CallSummary, type JoinResponse } from './api.js';
import { CallRoom } from './CallRoom.js';
import { PreJoin, type DeviceChoice } from './PreJoin.js';

export default function App() {
  const [credential, setCredential] = useState('');
  const [activeCredential, setActiveCredential] = useState('');
  const [calls, setCalls] = useState<CallSummary[]>([]);
  const [pendingCall, setPendingCall] = useState('');
  const [connection, setConnection] = useState<JoinResponse | null>(null);
  const [deviceChoice, setDeviceChoice] = useState<DeviceChoice>({ audioInput: undefined, audioOutput: undefined, videoInput: undefined });
  const [error, setError] = useState('');
  const api = useMemo(() => activeCredential ? new CallsApi(activeCredential) : null, [activeCredential]);

  useEffect(() => {
    if (!api || connection) return;
    let cancelled = false;
    const refresh = () => void api.listCalls().then((items) => { if (!cancelled) setCalls(items); }).catch(() => {});
    refresh();
    const timer = window.setInterval(refresh, 4000);
    return () => { cancelled = true; window.clearInterval(timer); };
  }, [api, connection]);

  if (connection && api) {
    return <CallRoom connection={connection} deviceChoice={deviceChoice} onLeave={async () => {
      await api.action(connection.callId, 'leave');
      setConnection(null);
    }} />;
  }

  async function join(choice: DeviceChoice) {
    if (!api || !pendingCall) return;
    setError('');
    try {
      const details = await api.join(pendingCall);
      setDeviceChoice(choice);
      setConnection(details);
    }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Ошибка входа'); }
  }

  if (pendingCall) return <div className="page"><PreJoin onReady={(choice) => void join(choice)} onCancel={() => setPendingCall('')} />{error && <p className="error">{error}</p>}</div>;

  if (!api) return <div className="page login"><section className="card">
    <p className="eyebrow">Мои чаты · 5.1 POC</p><h1>Закрытый пилот звонков</h1>
    <p>Введите отдельный синтетический credential A/B/C/D. Он хранится только в памяти вкладки и не является сессией 5.0.</p>
    <label>Тестовый credential<input type="password" autoComplete="off" value={credential} onChange={(event) => setCredential(event.target.value)} /></label>
    <button className="primary" disabled={credential.length < 16} onClick={() => setActiveCredential(credential)}>Открыть пилот</button>
  </section></div>;

  const open = calls.filter((call) => call.state !== 'ENDED');
  async function create(chatId: string, type: 'AUDIO' | 'VIDEO') {
    if (!api) return;
    setError('');
    try { const result = await api.createCall(chatId, type); setPendingCall(result.callId); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Ошибка создания звонка'); }
  }

  return <div className="page dashboard">
    <header><div><p className="eyebrow">Мои чаты · 5.1 POC</p><h1>Звонки</h1></div><button onClick={() => { setActiveCredential(''); setCredential(''); }}>Выйти</button></header>
    {error && <p className="error">{error}</p>}
    <section className="card"><h2>Начать звонок</h2>
      <div className="call-actions"><button onClick={() => void create(POC_CHATS.directAB, 'AUDIO')}>Аудио A ↔ B</button><button onClick={() => void create(POC_CHATS.directAB, 'VIDEO')}>Видео A ↔ B</button><button onClick={() => void create(POC_CHATS.groupABCD, 'VIDEO')}>Группа A/B/C/D</button></div>
    </section>
    <section className="card"><h2>Входящие и активные</h2>
      {open.length === 0 ? <p className="muted">Открытых звонков нет.</p> : open.map((call) => <article className="call-row" key={call.id}>
        <div><strong>{call.type === 'VIDEO' ? 'Видеозвонок' : 'Аудиозвонок'}</strong><small>{call.state} · {new Date(call.created_at).toLocaleString()}</small></div>
        <div className="row"><button className="primary" onClick={() => setPendingCall(call.id)}>Ответить / войти</button><button onClick={() => void api.action(call.id, 'decline')}>Отклонить</button></div>
      </article>)}
    </section>
  </div>;
}
